/* Ricochet redesign: sticky header group + scroll-reveal for all pages (plain braces). */
(function () {
  'use strict';
  var rvIo = null;
  function stickyHeader() {
    var group = document.getElementById('header-group');
    var nav = document.querySelector('.rk-inside.rk-headWrap');
    if (!group || !nav) { return; }
    var announce = document.querySelector('.rk-inside.rk-announce');
    var off = announce ? announce.offsetHeight : 0;
    group.style.position = 'sticky';
    group.style.top = '-' + off + 'px';
    group.style.zIndex = '50';
  }
  function init() {
    stickyHeader();
    if (rvIo) { rvIo.disconnect(); }
    rvIo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); rvIo.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.rk-inside .rv').forEach(function (el) {
      el.style.transitionDelay = (el.getAttribute('data-d') || 0) + 'ms';
      rvIo.observe(el);
    });
  }
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', stickyHeader);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
